/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useRef, useState} from 'react';
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import TextInput from "./BasicInputs/TextInput.jsx";
import Dom from "toolbox/dom";
import InfoTooltip from "./InfoTooltip.jsx";

function SmallSearch({value, onChange, children, placeholder}) {
    const [isSearchOpen, setIsSearchOpen] = useState(false)
    const searchRef = useRef(null);

    // Focus the input whenever the panel becomes visible
    useEffect(() => {
        if (isSearchOpen && searchRef.current) {
            searchRef.current.focus();

            Dom(searchRef.current).focusInput(value, value)
        }
    }, [isSearchOpen]);

    if (isSearchOpen) {
        return (<div className={"flex h-full w-full items-center"}>
            <div className=" w-full ">
                <TextInput hasSearch={true}
                           innerRef={searchRef}
                           className={"h-8! p-0.5! text-sm! w-full! min-w-full! max-w-full! border-stone-100! ring-0! shadow-none! outline-none! border-none!"}
                           value={value}
                           onChange={onChange}
                           hasClose={true}
                           onBlur={() => {
                  
                           }}
                           onCloseClick={() => {
                               setIsSearchOpen(false)
                               onChange("")
                           }}
                           placeholder={`Search Elements`}
                />
            </div>


        </div>)
    }

    return (
        <div className={"flex h-full w-full items-center"} onClick={(e) => setIsSearchOpen(true)}>
            <div className={"grow"}>
                {children}
            </div>
            <div className={"grow"}></div>
            <InfoTooltip text={placeholder} delay={2000}>


                <button className={"flex text-xs  justify-center items-center rounded-lg py-1 px-1 "}

                        onFocus={(e) => setIsSearchOpen(true)}>
                    <DisplayIcon iconName={"IoSearchOutline"} className="size-3 "/>
                </button>
            </InfoTooltip>
        </div>
    );
}

SmallSearch.propTypes = {};

SmallSearch.defaultProps = {};


export default SmallSearch;